import { v4 as uuid } from "uuid";

export const products = [
  {
    _id: uuid(),
    image: "./Assets/brand1.jpg",
    title: "casio",
    description: "A1486 Enticer Men's ( MTP-V002L-7B2UDF ) Analog Watch ",
    rating: 2,
    price: 5000,
    discount: 10,
    discountedPrice: 4500,
    categoryName: "analog",
    inStock: true,
    fastdelivery: true,
  },
  {
    _id: uuid(),
    title: "fastrack",
    image: "./Assets/digital-01.jpg",
    description: "fasttrack 38024PP27 Minimalists digital Watch",
    rating: 3,
    price: 3000,
    discount: 15,
    discountedPrice: 2550,
    categoryName: "digital",
    inStock: true,
    fastdelivery: false,
  },
  {
    _id: uuid(),
    title: "fossil",
    image: "/Assets/analog-digital-01.jpg",
    description: "FS5708SET Neutra Chrono Analog Digital Watch",
    rating: 4,
    price: 9500,
    discount: 20,
    discountedPrice: 7600,
    categoryName: "analog-digital",
    inStock: true,
    fastdelivery: true,
  },
  {
    _id: uuid(),
    title: "fastrack",
    image: "/Assets/brand2.jpg",
    description: "38044PP01 Trendies Analog Watch",
    rating: 5,
    price: 3500,
    discount: 5,
    discountedPrice: 3325,
    categoryName: "analog",
    inStock: true,
    fastdelivery: false,
  },
  {
    _id: uuid(),
    title: "fossil",
    image: "/Assets/digital-02.jpg",
    description: "FS5897 Retro Digital Watch ",
    rating: 2,
    price: 9900,
    discount: 25,
    discountedPrice: 7425,
    categoryName: "digital",
    inStock: false,
    fastdelivery: false,
  },
  {
    _id: uuid(),
    title: "casio",
    image: "/Assets/brand3.jpg",
    description: "AD250 (MWA-100H-1AVDF) Youth-Analog Analog Watch",
    rating: 3,
    price: 4000,
    discount: 12,
    discountedPrice: 3520,
    categoryName: "analog",
    inStock: false,
    fastdelivery: true,
  },
  {
    _id: uuid(),
    title: "titan",
    image: "/Assets/brand4.jpg",
    description: "AD250 (MWA-100H-1AVDF) Youth-Analog Analog Watch",
    rating: 3,
    price: 6500,
    discount: 17,
    discountedPrice: 5395,
    categoryName: "analog",
    inStock: true,
    fastdelivery: true,
  },
  {
    _id: uuid(),
    title: "fossil",
    image: "/Assets/analog-digital-02.jpg",
    description: "FS5708SET Neutra Chrono Analog Digital Watch",
    rating: 4,
    price: 9500,
    discount: 20,
    discountedPrice: 7600,
    categoryName: "analog-digital",
    inStock: true,
    fastdelivery: false,
  },
  {
    _id: uuid(),
    title: "titan",
    image: "/Assets/digital-03.jpg",
    description: "AD250 (WA-100H-1AVDF) Youth-digital Watch",
    rating: 1,
    price: 6000,
    discount: 30,
    discountedPrice: 4200,
    categoryName: "digital",
    inStock: false,
    fastdelivery: true,
  },
];
